import React from 'react';
import styles from '../styles/socialEntrance.module.scss';
import { useFacebookLogin } from '../hooks/facebookLogin';
import SocialEntranceButton from './socialEntranceButton';
import { useGoogleAuth } from '../hooks/googleLogin';
import useAppleLogin from '../hooks/useAppleLogin';
import { ReactComponent as Apple } from '@ui-kit/icons/apple.svg';
import { ReactComponent as Google } from '@ui-kit/icons/google.svg';
import { ReactComponent as Facebook } from '@ui-kit/icons/facebook.svg';

export default function SocialEntrance() {
  const { login } = useFacebookLogin();
  const { loginGoogle } = useGoogleAuth();
  const { login: appleLogin } = useAppleLogin();

  return (
    <div className={styles.authSocial}>
      <SocialEntranceButton
        onClick={login}
        style={{ backgroundColor: '#3F62AA' }}
      >
        <Facebook />
      </SocialEntranceButton>
      <SocialEntranceButton
        onClick={loginGoogle}
        style={{ backgroundColor: '#BA473E' }}
      >
        <Google />
      </SocialEntranceButton>
      <SocialEntranceButton
        onClick={appleLogin}
        style={{ backgroundColor: '#1A1A1A' }}
      >
        <Apple />
      </SocialEntranceButton>
    </div>
  );
}
